/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "redux/store";
import { IAddLifeOrderTypes, IInvoice } from "shared/interface/types";

const initialState: { LifeOrder: IAddLifeOrderTypes; Invoice: IInvoice } = {
  LifeOrder: {
    id: "",
    customerDetailId: "",
    name: "",
    lifePlanId: null,
    planName: "",
    productName: "",
    cartId: "",
    lineOfBussiness: {
      id: null,
      name: ""
    },
    takafulProvider: {
      id: "",
      companyName: ""
    },
    paymentFrequency: {
      id: null,
      name: ""
    },
    planType: {
      id: null,
      name: ""
    }
  },
  Invoice: {
    id: "",
    dueDate: "",
    amount: "",
    currencySymbol: "",
    paidAt: "",
    currencyId: 0,
    tax: "",
    createdById: "",
    updatedById: "",
    createdAt: "",
    updatedAt: "",
    activityFkId: "",
    payerUserId: "",
    paymentStatusId: 0,
    pickupAddress: "",
    activity: {
      id: 0,
      value: ""
    },
    type: {
      id: 0,
      value: ""
    },
    paymentStatus: {
      id: 0,
      key: "",
      value: ""
    },
    paymentMode: {
      id: 0,
      value: ""
    },
    paymentMethod: {
      id: 0,
      value: ""
    },
    currency: {
      id: 0,
      name: "",
      code: "",
      symbol: ""
    },
    totalContributionValue: "",
    amountValue: "",
    updatedBy: {
      id: 0,
      name: ""
    },
    payer: {
      id: "",
      contactNumber: "",
      name: "",
      isActive: true,
      email: "",
      profileImage: "",
      userType: {
        id: 0,
        key: ""
      }
    }
  }
};

const lifeOrderSlice = createSlice({
  name: "lifeOrder",
  initialState,
  reducers: {
    AddLifeOrder: (state, action) => {
      state.LifeOrder = action.payload;
    },
    AddOrderInvoice: (state, action) => {
      state.Invoice = action.payload;
    },
    DeleteLifeOrder: state => {
      state.LifeOrder = initialState.LifeOrder;
    }
  }
});

export const { AddLifeOrder, AddOrderInvoice, DeleteLifeOrder } = lifeOrderSlice.actions;
export default lifeOrderSlice.reducer;

export const getLifeOrder = (state: RootState) => state.lifeOrder;
export const getInvoice = (state: RootState) => state.lifeOrder;
